import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import { scale } from "../utils/utils";
import "./midi-in";

class MidiContainer extends LitElement {
  static get properties() {
    return {};
  }

  constructor() {
    super();

    // web midi setup
    WebMidi.enable((error) => {
      if (error) {
        console.log(error);
      } else {
        // set up IAC Bus 1 CC
        const IACBus01 = WebMidi.getInputByName("IAC Driver Bus 1");
        if (IACBus01) {
          IACBus01.addListener(
            "noteon",
            "all",
            this.handleIACBus01NoteOn.bind(this)
          );
          IACBus01.addListener(
            "noteoff",
            "all",
            this.handleIACBus01NoteOff.bind(this)
          );
        }
      }
    });
  }

  handleIACBus01NoteOn(e) {}

  handleIACBus01NoteOff(e) {}

  getRGBValue(val) {
    return scale(val, 0, 127, 0, 255);
  }

  render() {
    if (WebMidi.supported) {
      return html`
        <midi-in
          source="ADDA's iPad"
          channel="all"
          width="100%"
          height="100%"
          size="2"
          startColor="rgb(150, 20, 40)"
          endColor="rgb(255, 98, 89)"
          noteOpacity="0.8"
          backgroundColor="transparent"
        ></midi-in>
      `;
    } else {
      return html``;
    }
  }
}

customElements.define("midi-container", MidiContainer);
